import Cookies from "js-cookie";

import {
  AD_SOURCE_COOKIE_KEY,
  extractAdSourceFromDeepLink,
  extractQuerySourceFromDeepLink,
  isAdSkipSource,
} from "./adSource";
import { setAdSourceInStore, setQuerySourceInStore } from "./adSourceStore";

const COOKIE_OPTIONS: Cookies.CookieAttributes = {
  expires: 365,
  path: "/",
  sameSite: "Lax",
};

function withSecureFlag(): Cookies.CookieAttributes {
  if (typeof window === "undefined") {
    return COOKIE_OPTIONS;
  }
  return {
    ...COOKIE_OPTIONS,
    secure: window.location.protocol === "https:",
  };
}

/** 读取本地 ad_source cookie；无则 null。 */
export function getAdSourceCookie(): string | null {
  if (typeof document === "undefined") {
    return null;
  }
  const raw = Cookies.get(AD_SOURCE_COOKIE_KEY)?.trim();
  return raw ? raw : null;
}

/**
 * 写入 ad_source cookie。
 * 调用方负责覆盖语义：后端 ownerInfo.ad_source 优先覆盖本地（见 useOnboardingEntryGate / fetchUserInfo）。
 */
export function setAdSourceCookie(value: string): void {
  if (typeof document === "undefined") {
    return;
  }
  const trimmed = value?.trim();
  if (!trimmed) {
    return;
  }
  Cookies.set(AD_SOURCE_COOKIE_KEY, trimmed.toUpperCase(), withSecureFlag());
}

/** 清除 ad_source cookie（登录上报成功后可选清理）。 */
export function clearAdSourceCookie(): void {
  if (typeof document === "undefined") {
    return;
  }
  Cookies.remove(AD_SOURCE_COOKIE_KEY, { path: "/" });
}

/** 当前 cookie 的 ad_source 是否应跳过 onboarding 直落 Brief。 */
export function shouldAdSkipOnboarding(): boolean {
  return isAdSkipSource(getAdSourceCookie());
}

/** 从深链 payload 提取 ad_source + query_source 并写入（ad_source→cookie+store，query_source→仅 store）。 */
export function captureAdSourceFromDeepLink(
  data: Parameters<typeof extractAdSourceFromDeepLink>[0],
): string | null {
  const adSource = extractAdSourceFromDeepLink(data);
  if (adSource) {
    setAdSourceCookie(adSource);
    setAdSourceInStore(adSource);
  }
  // query_source：只存 store，不存 cookie
  const querySource = extractQuerySourceFromDeepLink(data);
  if (querySource) {
    setQuerySourceInStore(querySource);
  }
  return adSource;
}
